<nav class="nxe-breadcrumbs" [attr.aria-label]="'filemanager.ui.path' | translate">
    @for (crumb of breadcrumbs$ | async; track $index; let first = $first; let last = $last) {
        @if (!first) {
            <span class="nxe-breadcrumb-separator" aria-hidden="true">›</span>
        }
        <button type="button" (click)="click(crumb)" class="nxe-breadcrumb-button"
                [class.current]="last" [attr.aria-current]="last ? 'location' : null">
            {{ first ? ('filemanager.ui.root' | translate) : (crumb.name | nxeFolderName) }}
        </button>
    }
</nav>
